export default "__VITE_ASSET__c7961512__"